import styled from "styled-components";

import { device } from "../../theme/device";

export const CardSection = styled.div`
  display: grid;
  grid-template-columns:
    [full-start] minmax(4rem, 1fr) [center-start] repeat(
      14,
      [col-start] minmax(min-content, 14rem) [col-end]
    )
    [center-end] minmax(4rem, 1fr)
    [full-end];
  padding-bottom: 7.5rem;

  @media ${device.phone} {
    justify-content: center;
  }
`;

export const Container = styled.div`
  grid-column: center-start / center-end;

  display: grid;
  //grid-template-columns: repeat(3, 1fr);
  grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
  grid-gap: 2rem;
  align-items: center;
  align-content: center;

  @media (max-width: 325px) {
    padding-left: 1rem;
  }
`;



// WEBPACK FOOTER //
// ./src/UI/ContentSection/ContentSection.js